import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  selectInputStyle: {
    border: "1px solid #93A9BD",
    background: "#fff",
    color: "#465869",
    boxSizing: "border-box",
    height: "32px",
    width: "129px",
    position: "relative",
    textIndent: "3.3rem",
    paddingLeft: ".8rem",
  },
  spanCustomerSelect: {
    position: "absolute",
    left: "8px",
    top: 5,
    color: "#9ca6af",
  },

  alignTextLeft: {
    textAlign: "left",
  },

  alignCapitalizedText: {
    textAlign: "left",
    textTransform: "capitalize",
  },
  iconExtraAction: {
    cursor: "pointer",
  },
  buttonInvite: {
    display: "flex",
    alignItems: "center",
    "& span": {
      whiteSpace: "nowrap",
      marginLeft: "8px",
    },
  },
  noWhiteSpace: {
    whiteSpace: "nowrap",
  },
}));

export default styles;
